"use strict";

exports.__esModule = true;

function rgbToHSL(_a) {
  var _r = _a[0],
      _g = _a[1],
      _b = _a[2];
  var r = _r;
  var g = _g;
  var b = _b;
  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h,
      s,
      l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return [h, s, l];
}

function rgbStringToHSL(_rgb) {
  var sep = _rgb.indexOf(",") > -1 ? "," : " ";

  var str = _rgb.substr(4).split(")")[0].split(sep);

  var rgb = [undefined, undefined, undefined];

  for (var s in str) {
    var r = str[s];
    rgb[s] = Math.round(parseInt(r));
  }

  return rgbToHSL(rgb);
}

exports.rgbStringToHSL = rgbStringToHSL;
exports["default"] = rgbToHSL;